export default __webpack_public_path__ + "static/media/kek.7f97723f.jpg";